<template>
  <div class="homePage">
    <!-- 第一部分 -->
    <div class="indexBox flex">
      <div class="indexLeft">
        <el-carousel trigger="click" height="360px">
          <el-carousel-item v-for="(item, index) in navImgs" :key="index">
            <img :src="item.img" alt="" height="360px" width="600px"/>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="indexLeft" style="padding: 0 18px;">
        <img src="../assets/images/gzjl_item.png" alt="" style="cursor: pointer;" class="title" @click="$router.push('news?type=1')"/>
        <!-- 列表 -->
        <div class="listBox flex align-center justify-between flex-1" v-for="(item, index) in jlList" :key="index" @click="getDetails(item.noticeId,1)">
          <div class="flex align-center listBoxleft">
            <div class="listBoxLine">◆</div>
            <div class="listBoxTitle">{{ item.noticeTitle }}</div>
          </div>
          <div class="listBoxTime">{{ item.createTime }}</div>
        </div>
      </div>
    </div>
    <!-- 六大块 -->
    <div class="centerBox margin-top">
      <!-- 通知公告 -->
      <div class="centerBox_item">
        <img src="../assets/images/tzgg_item.png" alt="" class="topIcon cursor" @click="$router.push('tzgg?type=2')"/>
        <!-- 列表 -->
        <div class="centerBox_content flex align-center" v-for="(item, index) in listBox" @click="getDetails(item.noticeId,2)" :key="index">
          <div class="centerBoxLine">●</div>
          <div class="centerBoxTitle">{{ item.noticeTitle }}</div>
        </div>
      </div>
      <!-- 行业动态 -->
      <div class="centerBox_item">
        <img src="../assets/images/hydt_item.png" alt="" class="topIcon cursor" @click="$router.push('hydt?type=5')"/>
        <img src="../assets/images/dongtai_pic.png" alt="" class="hybanner" style="margin-top: 15px;"/>
        <!-- 列表 -->
        <div class="centerBox_content flex align-center" v-for="(item, index) in hydtList" v-if="index < 4" :key="index" @click="getDetails(item.noticeId,5)">
          <div class="centerBoxLine">●</div>
          <div class="centerBoxTitle">{{ item.noticeTitle }}</div>
        </div>
      </div>
      <!-- 司法鉴定机构查询 -->
      <div class="centerBox_item">
        <img src="../assets/images/jgcx_item.png" alt="" class="topIcon"/>
        <!-- 列表 -->
        <div class="centerBox_content flex align-center" v-for="(item, index) in jdjgList" :key="index" @click="getDetails(item.noticeId,7)">
          <div class="centerBoxLine">●</div>
          <div class="centerBoxTitle">{{ item.noticeTitle }}</div>
        </div>
      </div>
      <!-- 司法鉴定人查询 -->
      <div class="centerBox_item">
        <img src="../assets/images/jdr_item.png" alt="" class="topIcon"/>
        <!-- 列表 -->
        <div class="centerBox_content flex align-center" v-for="(item, index) in jdrfcList" :key="index" @click="getDetails(item.noticeId,8)">
          <div class="centerBoxLine">●</div>
          <div class="centerBoxTitle">{{ item.noticeTitle }}</div>
        </div>
      </div>
      <!-- 鉴定服务 -->
      <div class="centerBox_item">
        <img src="../assets/images/jdfw_item.png" alt="" class="topIcon"/>
        <!-- 列表 -->
        <div class="fwBox margin-top-sm">
          <div class="fwBoxItem flex align-center justify-center flex-column" v-for="(item, index) in jdfw" :key="index" @click="jdfuF(item.path)" >
            <img :src="item.img" alt="" class="fwBoxIcon" />
            <div class="fwBoxText">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <!-- 协会服务 -->
      <div class="centerBox_item">
        <img src="../assets/images/xhfw_item.png" alt="" class="topIcon"/>
        <!-- 列表 -->
        <div class="fwBox margin-top-sm">
          <div class="fwBoxItem flex align-center justify-center flex-column" v-for="(item, index) in xhfw" :key="index" @click="xhfwF(item.path)" >
            <img :src="item.img" alt="" class="fwBoxIcon" />
            <div class="fwBoxText">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 案情描述 -->
    <div class="caseMs">
      <div class="caseMs_box">
        <div class="caseMs_item">
          <img src="../assets/images/ajxq_01.jpg" alt="" class="hybanner"/>
          <!-- 列表 -->
          <div class="centerBox_content flex align-center" v-for="(item, index) in dxalList.slice(0,3)" @click="getDetails(item.noticeId,3)" :key="index">
            <div class="centerBoxLine">●</div>
            <div class="centerBoxTitle">{{ item.noticeTitle }}</div>
          </div>
        </div>
        <div class="caseMs_item">
          <img src="../assets/images/ajxq_06.jpg" alt="" class="hybanner"/>
          <!-- 列表 -->
          <div class="centerBox_content flex align-center" v-for="(item, index) in dxalList.slice(3,6)" @click="getDetails(item.noticeId,3)" :key="index">
            <div class="centerBoxLine">●</div>
            <div class="centerBoxTitle">{{ item.noticeTitle }}</div>
          </div>
        </div>
        <div class="caseMs_item">
          <img src="../assets/images/ajxq_09.jpg" alt="" class="hybanner"/>
          <!-- 列表 -->
          <div class="centerBox_content flex align-center" v-for="(item, index) in dxalList.slice(6,9)" @click="getDetails(item.noticeId,3)" :key="index">
            <div class="centerBoxLine">●</div>
            <div class="centerBoxTitle">{{ item.noticeTitle }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 图标 -->
    <div class="iconBox">
      <div class="icon_box flex align-center justify-between">
        <div class="icon_item flex flex-column align-center" v-for="(item, index) in iconBox" :key="index">
          <img :src="item.img" alt="" class="iconImg"/>
          <div class="iconTitle">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../assets/css/homePage.less';
import {noticeListAPI} from "@/api/home";
import {banners, iconBox, jdfwList, xhfwList} from "@/utils/mack";

export default {
  name: 'index',
  data() {
    return {
      navImgs: [],
      jdrfcList: [],
      jlList: [],
      hydtList: [],
      jdjgList: [],
      dxalList: [],
      jdfw: [],
      xhfw: [],
      listBox: [],
      iconBox: [],
    };
  },
  mounted() {
    this.navImgs = banners
    // 工作交流
    this.getlist(1)
    // 通知公告
    this.getlist(2)
    // 行业动态
    this.getlist(5)
    // 鉴定机构
    this.getlist(7)
    // 鉴定人查询
    this.getlist(8)
    // 典型案例
    this.getlist(3)
    // 鉴定服务
    this.jdfw = jdfwList
    // 协会服务
    this.xhfw = xhfwList
    // 图标
    this.iconBox = iconBox
  },
  methods: {
    // 通知公示列表
    getlist(type) {
      noticeListAPI(type).then(res => {
        const { code, rows, total, msg } = res
        if (code === 200) {
          switch (type) {
            case 1:
              this.jlList = rows.slice(0, 8)
              break;
            case 2:
              this.listBox = rows.slice(0, 9)
              break;
            case 3:
              this.dxalList = rows.slice(0, 9)
              break;
            case 5:
              this.hydtList = rows.slice(0, 4)
              break;
            case 7:
              this.jdjgList = rows.slice(0, 9)
              break;
            case 8:
              this.jdrfcList = rows.slice(0, 9)
              break;
          }
        } else {
          this.$message.error(msg || '获取列表失败')
        }
      })
    },
    // 跳转详情
    getDetails(id, type) {
      sessionStorage.setItem('type', type)
      this.$router.push('/newsDetails?newsId=' + id)
    },
    // 鉴定服务
    jdfuF(path) {
      if (path === 'px' || path === '') {
        this.$message({
          message: '暂未开放',
          type: 'warning'
        });
      } else if (path === '/jdapply') {
        if (localStorage.getItem('token')) {
          this.$router.push('/grht')
        } else {
          this.$router.push(path)
        }
      } else {
        this.$router.push(path)
      }

    },
    // 协会服务
    xhfwF(path) {
      if (path === '/aboutxh') {
        this.$router.push(path)
      } else if (path === 1) {
        window.open('http://hbsfjd.intcont.bjzjtp.com', '_blank')
      } else if (path === 3) {
        this.$router.push('/jdwshy')
      } else {
        this.$message({
          message: '暂未开放',
          type: 'warning'
        });
      }
    },

  },
};
</script>
